import React from 'react';
import './Download.css';


const data = [
  { id: 2, title: 'Syllabus', download: '/Affiliation/14-55_ER_20 _syllabus_23092021 (1).pdf' },
    {
    id: 13,
    title: 'Affidavit Student',
    download: '/Admission Form/Affidavit___Student_-2023-1.docx',
  },
  {
    id: 14,
    title: 'Admission Form',
    download: '/Admission Form/164812982088.pdf',
  },
  {
    id: 15,
    title: 'Student Performa',
    download: '/Admission Form/164813022248.pdf',
  },
  {
    id: 16,
    title: 'Job Application',
    download: '/Admission Form/165509642338.pdf.pdf',
  },
  {
    id: 17,
    title: 'Gap years Certificate',
    download: '/Admission Form/Gap years Certificate.pdf',
  },
  // {
  //   id: 18,
  //   title: 'Student Correction',
  //   download: '/Admission Form/Student Correction Affidavit.pdf',
  // },
  {
    id: 19,
    title: 'D PHARMA SCHOOL 2024-25 HSTES LIST',
    download: '/Affiliation/D PHARMA SCHOOL 2024 HSTES LIST.pdf',
  },
  {
    id: 20,
    title: 'Re Constitution of anti discrimination of committee Notice',
    download: '/IQAC/Re Constitution of anti discrimination of committee Notice.pdf',
  },
  // {
  //   id: 21,
  //   title: 'Re Constitution of Anti Ragging Committee Notice',
  //   download: '/IQAC/Re Constitution of Anti Ragging Committee Notice.pdf',
  // },
  {
    id: 22,
    title: 'Re Constitution of career guidance and placement committee notice',
    download: '/IQAC/Re Constitution of career guidance and placement committee notice.pdf',
  },
  {
    id: 23,
    title: 'Re- Constitution of gender Sensitization  cell',
    download: '/IQAC/Re- Constitution of gender Sensitization  cell.pdf',
  },
  {
    id: 24,
    title: '2023 Result',
    download: '/IQAC/2023 REGULAR.pdf',
  },
  {
    id: 25,
    title: 'Faculty List',
    download: '/IQAC/SCHOOL FACULTY LIST (1).pdf',
  },
];


const Download = () => {
  return (
    <div className='main-container-download'>
      <div className='container-download-image'>
        {/* <Slide></Slide> */}
      </div>
      <div className='container-download-content'>
        <div data-aos='flip-left' data-aos-easing='ease-out-cubic' data-aos-duration='2000'>
          <h1>Download Technology Syllabus and Form</h1>
          <div className="table-wrapper">
            <table className="download-table">
              <thead>
                <tr>
                  <th>Serial No.</th>
                  <th>Title</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td>
                      <a
                        href={item.download} 
                        download
                        className='down-btn' 
                      > 
                        <span className="button_lg">
                          <span className="button_sl"></span>
                          <span className="primary-button">Download Now</span>
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;


